import React, { useEffect, useState, useRef } from 'react';

import { useScript } from "../../helpers/useScript"
import useMediaQuery from "../../helpers/useMediaQuery";
import { styled } from "../../stitches.config"
import TaboolaSkeleton from './TaboolaSkeleton';

import { ConsentConditional } from '../../components/HOCs/withConsent';

interface ITaboola {
    displaySimiliarArticles?: boolean;
};

const Taboola: React.FC<ITaboola> = ({ displaySimiliarArticles }) => {
    const isDesktop = useMediaQuery('bp4');
    const [isTaboolaLoad, setTaboolaLoad] = useState<boolean>(false);

    const ref = useRef<HTMLDivElement>(null);

    const w = (window as any);
    w._taboola = w._taboola || [];
    w._taboola.push({ article: 'auto' });

    let scriptPublicId = `natematgroup-${window.SERVICE_INSTANCE_ID}`;
    useScript(`//cdn.taboola.com/libtrc/${scriptPublicId}/loader.js`, { id: 'tb_loader_script' }, "none");

    useEffect(() => {
        const w = (window as any);

        w._taboola.push({
            mode: 'thumbnails-a' + (isDesktop ? '' : '-mobile'),
            container: 'taboola-below-article-thumbnails',
            placement: 'Below Article Thumbnails',
            target_type: 'mix'
        });

        w._taboola.push({ flush: true });
    }, []);

    useEffect(() => {
        if (!displaySimiliarArticles)
            return;

        var observer = new MutationObserver((m) => m.forEach((mutation) => {
            if (mutation.type == "childList") {
                setTaboolaLoad(true);
                observer.disconnect();
            }
        }));
        if (ref.current) {
            observer.observe(ref.current, { childList: true, subtree: true });
        }
        return () => {
            observer.disconnect();
        }

    }, []);

    if (!displaySimiliarArticles)
        return null;

    return (
        <TaboolaWrapper>
            <div ref={ref} id="taboola-below-article-thumbnails"></div>
            {!isTaboolaLoad && <TaboolaSkeleton numberOfBoxes={8} />}
        </TaboolaWrapper>
    );
};
const TaboolaWrapper = styled('div', {
    //minHeight: "2721px",
});

const TaboolaWithConsent = (props: ITaboola) => (
    <ConsentConditional>
        <Taboola {...props} />
    </ConsentConditional>
)

export default (props: ITaboola) => (
    <div className="container">
        <TaboolaWithConsent {...props} />
    </div>
);